export default __webpack_public_path__ + "static/media/V545MANF1.2900b612.pdf";